/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssistantChatPostRequest,
  AssistantClearHistoryPostRequest,
  AssistantConversationsGet200Response,
  AssistantLoadConversationGet200Response,
} from '../models/index';
import {
    AssistantChatPostRequestFromJSON,
    AssistantChatPostRequestToJSON,
    AssistantClearHistoryPostRequestFromJSON,
    AssistantClearHistoryPostRequestToJSON,
    AssistantConversationsGet200ResponseFromJSON,
    AssistantConversationsGet200ResponseToJSON,
    AssistantLoadConversationGet200ResponseFromJSON,
    AssistantLoadConversationGet200ResponseToJSON,
} from '../models/index';

export interface AssistantChatPostOperationRequest {
    assistantChatPostRequest: AssistantChatPostRequest;
}

export interface AssistantClearHistoryPostOperationRequest {
    assistantClearHistoryPostRequest: AssistantClearHistoryPostRequest;
}

export interface AssistantLoadConversationGetRequest {
    conversationId: string;
}

/**
 * 
 */
export class AssistantApi extends runtime.BaseAPI {

    /**
     */
    async assistantChatPostRaw(requestParameters: AssistantChatPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistantChatPostRequest'] == null) {
            throw new runtime.RequiredError(
                'assistantChatPostRequest',
                'Required parameter "assistantChatPostRequest" was null or undefined when calling assistantChatPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/assistant/chat`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssistantChatPostRequestToJSON(requestParameters['assistantChatPostRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assistantChatPost(requestParameters: AssistantChatPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assistantChatPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async assistantClearHistoryPostRaw(requestParameters: AssistantClearHistoryPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistantClearHistoryPostRequest'] == null) {
            throw new runtime.RequiredError(
                'assistantClearHistoryPostRequest',
                'Required parameter "assistantClearHistoryPostRequest" was null or undefined when calling assistantClearHistoryPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/assistant/clear-history`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssistantClearHistoryPostRequestToJSON(requestParameters['assistantClearHistoryPostRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assistantClearHistoryPost(requestParameters: AssistantClearHistoryPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assistantClearHistoryPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async assistantConversationsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistantConversationsGet200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/assistant/conversations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistantConversationsGet200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async assistantConversationsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistantConversationsGet200Response> {
        const response = await this.assistantConversationsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async assistantLoadConversationGetRaw(requestParameters: AssistantLoadConversationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistantLoadConversationGet200Response>> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling assistantLoadConversationGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['conversationId'] != null) {
            queryParameters['conversationId'] = requestParameters['conversationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/assistant/load-conversation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistantLoadConversationGet200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async assistantLoadConversationGet(requestParameters: AssistantLoadConversationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistantLoadConversationGet200Response> {
        const response = await this.assistantLoadConversationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
